import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("landing-page-text-centered", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("landing-page-text-centered"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });

  BlockManager.add("landing-page-text-centered", {
    ...config,
    label: "Text centered",
    content: template,
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches(".landing-page-text-centered__title *")) data.enabled = false;
    }
  });
}
